/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_PriorityInputs */

const en_qk_priority = /** @type {(inputs: Qk_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p0 to p3, or none`)
};

const de_qk_priority = /** @type {(inputs: Qk_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p0 bis p3 oder none`)
};

/**
* | output |
* | --- |
* | "p0 to p3, or none" |
*
* @param {Qk_PriorityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_priority = /** @type {((inputs?: Qk_PriorityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_PriorityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_priority(inputs)
	return en_qk_priority(inputs)
});